export interface MToggleProps {
  modelValue?: boolean;
  label?: string;
  name?: string;
  ariaLabel?: string;
}

export const mToggleDefaults = {} satisfies Partial<MToggleProps>;
